import { Controller } from "@hotwired/stimulus"

// The first landing's fireworks (#3279): a fixed, full-viewport overlay of
// bursts staggered across the page, each a ring of particles flung out and
// falling. Per-particle values go through the CSSOM, the one route the CSP
// leaves open: style-src has no 'unsafe-inline', so a style attribute in
// markup is dropped. No Math.random: a hash jitter keeps the pattern the
// same on every landing and in the rig.
const BURSTS = 7
const PARTICLES = 26
const SPREAD_MS = 2600
const BURST_MS = 1600
const COLORS = ["#fbd0b9", "#f9a97e", "#ffffff", "#d6f0c2", "#ffe08a", "#9cc9ff"]
// Bursts take evenly spaced columns across the width, in this order, so the
// whole page gets one and they do not sweep left to right
const COLUMNS = [3, 0, 5, 1, 6, 2, 4]

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.remove()
      return
    }
    for (let index = 0; index < BURSTS; index++) this.element.append(this.#burst(index))
    this.timer = setTimeout(() => this.element.remove(), SPREAD_MS + BURST_MS + 200)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  #burst(index) {
    const burst = document.createElement("div")
    burst.className = "home-fireworks__burst"
    burst.style.setProperty("--x", `${Math.round(10 + (COLUMNS[index] / (BURSTS - 1)) * 80 + (jitter(index) - 0.5) * 8)}%`)
    burst.style.setProperty("--y", `${Math.round(12 + jitter(index + 11) * 46)}%`)
    burst.style.setProperty("--delay", `${Math.round((index / BURSTS) * SPREAD_MS + jitter(index + 23) * 180)}ms`)
    for (let p = 0; p < PARTICLES; p++) {
      const particle = document.createElement("i")
      particle.className = "home-fireworks__particle"
      const angle = (p / PARTICLES) * Math.PI * 2 + jitter(index * 100 + p) * 0.35
      const distance = 80 + jitter(index * 100 + p + 7) * 160
      particle.style.setProperty("--dx", `${Math.round(Math.cos(angle) * distance)}px`)
      particle.style.setProperty("--dy", `${Math.round(Math.sin(angle) * distance)}px`)
      particle.style.setProperty("--color", COLORS[(index + p) % COLORS.length])
      particle.style.setProperty("--spin", `${Math.round(jitter(index * 100 + p + 13) * 720 - 360)}deg`)
      burst.append(particle)
    }
    return burst
  }
}

function jitter(n) {
  const x = Math.sin(n * 12.9898 + 78.233) * 43758.5453
  return x - Math.floor(x)
}
